import { useState, useEffect } from 'react';

export function useRandomCounter() {
  const [showCounter, setShowCounter] = useState(false);

  useEffect(() => {
    // Function to show counter for a brief period
    const showCounterBriefly = () => {
      setShowCounter(true);
      setTimeout(() => setShowCounter(false), 2000); // Hide after 2 seconds
    };

    // Show initial counter with a random delay
    const initialDelay = Math.random() * 3000 + 2000;
    const initialTimer = setTimeout(showCounterBriefly, initialDelay);

    // Set up interval for random appearances
    const interval = setInterval(() => {
      if (Math.random() < 0.3) { // 30% chance to show counter
        showCounterBriefly();
      }
    }, 5000); // Check every 5 seconds

    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);

  return showCounter;
}